/**
 * @author Code Lai（赖传峰）
 * @email codelai@staritgp.com
 * @date 2019-05-09 15:08
 */
import { AccountBalanceContext } from 'component/HOC/withAccountBalance'
import { LangContext } from 'component/HOC/withLang'
import { MyAssetsContext } from 'component/HOC/withMyAssets'
import { PaymentPasswordContext } from 'component/HOC/withPaymentPassword'
import { PrivilegeUseContext } from 'component/HOC/withPrivilegeUse'
import { ShopsContext } from 'component/HOC/withShops'
import { UserInfoContext } from 'component/HOC/withUserInfo'
import { createContext } from 'react'
import { FEEDBACK_CONSULT } from '../../en/admin/feedbacks/src/@feedbacks'

const FeedbackContext = createContext<{
  setFeedbackVisible(val: boolean): void
  setInitialFeedbackSelectedConsult (val: FEEDBACK_CONSULT): void
  setInitialFeedbackRelationNo (val: string): void
    }>({
      setFeedbackVisible: () => {},
      setInitialFeedbackSelectedConsult: () => {},
      setInitialFeedbackRelationNo: () => {},
    })

export {
  LangContext,
  PrivilegeUseContext,
  ShopsContext,
  UserInfoContext,
  AccountBalanceContext,
  FeedbackContext,
  MyAssetsContext,
  PaymentPasswordContext,
}
